import { Link } from "react-router-dom";
import { Settings, ArrowUpRight } from "lucide-react";
import { Brand } from "@/components/Brand";
import { Flag } from "@/context/SiteFlagsContext";
import { RedFooterColumn } from "@/components/pending-services/RedMenu";

export const Footer = () => (
  <footer className="bg-[#13315C] text-white/70" data-testid="public-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
      <div className="grid md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <Brand light />
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            Compraventa, validación, firma y seguimiento de transferencias vehiculares en una sola plataforma.
          </p>
          <Link
            to="/admin/login"
            title="Acceso administración"
            aria-label="Acceso administración"
            data-testid="footer-admin-gear"
            className="group mt-5 inline-flex items-center gap-2 text-xs font-semibold text-white/60 hover:text-[#F5B301] transition-colors"
          >
            <Settings size={15} className="transition-transform duration-500 group-hover:rotate-90" />
            Administración
          </Link>
        </div>
        <div>
          <p className="tf-label text-white/50 mb-4">Producto</p>
          <ul className="space-y-2.5 text-sm">
            <li><a href="/#como-funciona" className="hover:text-white">Cómo funciona</a></li>
            <li><a href="/#informe" className="hover:text-white">Informe 360</a></li>
            <li><Link to="/comparativa" className="hover:text-white">Comparativa</Link></li>
            <li><Link to="/verificar" className="hover:text-white">Verificar informe</Link></li>
            {/* servicio pendiente — reactivar vía flag en Cerebro (escanearQr) */}
            <Flag name="escanearQr"><li><Link to="/escanear" className="hover:text-white" data-testid="footer-escanear">Escanear QR</Link></li></Flag>
            <li><Link to="/precios" className="hover:text-white">Precios</Link></li>
          </ul>
        </div>
        {/* servicio pendiente — reactivar vía flag en Cerebro (enLaRedTodo) */}
        <Flag name="enLaRedTodo"><RedFooterColumn /></Flag>
        <div>
          <p className="tf-label text-white/50 mb-4">Empresa</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/como-operamos" className="hover:text-white" data-testid="footer-como-operamos">Sobre Transfiérelo</Link></li>
            <li><Link to="/cuanto-vale" className="hover:text-white" data-testid="footer-cuanto-vale">¿Cuánto vale mi auto?</Link></li>
            <li>
              <Link
                to="/inversionistas"
                className="hover:text-[#F5B301] inline-flex items-center gap-1.5 font-semibold"
                data-testid="footer-pitch-link"
              >
                Para inversionistas
                <ArrowUpRight size={12} className="text-[#F5B301]" />
              </Link>
            </li>
            <li>
              <a href="mailto:contacto@transfierelo.cl" className="hover:text-white">contacto@transfierelo.cl</a>
            </li>
          </ul>
          <p className="tf-label text-white/50 mt-6 mb-2 text-[10px]">Cumplimiento</p>
          <ul className="space-y-1 text-xs text-white/50">
            <li>Ley 19.628 · Privacidad</li>
            <li>Ley 21.719 · Datos personales</li>
            <li>Ley 19.799 · Firma electrónica</li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs">
        <p>© {new Date().getFullYear()} Transfiérelo · Plataforma demostrativa.</p>
        <p className="text-white/55">Integraciones biométricas y de firma en modo demostración.</p>
      </div>
    </div>
  </footer>
);
